import { z } from 'zod';
import { Currency } from '@40seas/models';
import { EnumSchema, FromSchema } from '@40seas/entities/common';

export const CurrencyConversionTransactionPayloadSchema = z
    .object({
        to: EnumSchema(Currency),
        from: EnumSchema(Currency),
        rate: z.number(),
    })
    .strict();

export class CurrencyConversionTransactionPayload extends FromSchema(CurrencyConversionTransactionPayloadSchema) {
    to: Currency;
    from: Currency;
    rate: number;
}
